import axios from '@/axios/api.request'

export const save = (from) => axios.request({
  url: '/patent/info/save',
  data: from,
  method: 'post'
})

export const addOut = (from) => axios.request({
  url: '/patent/info/add/out',
  data: from,
  method: 'post'
})

export const decp = (from) => axios.request({
  url: '/patent/info/decp',
  data: from,
  method: 'post'
})

export const dist = (from) => axios.request({
    url: '/patent/info/dist',
    data: from,
    method: 'post'
  })

export const list = (from) => axios.request({
  url: '/patent/info/list',
  data: from,
  method: 'post'
})

export const reduction = (from) => axios.request({
    url: '/patent/reduction/save',
    data: from,
    method: 'post'
  })
export const firstAudit = (from) => axios.request({
    url: '/patent/info/firstAudit',
    data: from,
    method: 'post'
  })
export const lastAudit = (from) => axios.request({
    url: '/patent/info/lastAudit',
    data: from,
    method: 'post'
  })

export const edit = (from) => axios.request({
  url: '/patent/info/edit',
  data: from,
  method: 'post'
})